import { Schedule, Info, CheckCircle, Cancel } from '@mui/icons-material';

export const DECISION_NODES = {
  APPROVED: { name: 'Aprobada', id: -1 },
  REJECTED: { name: 'Rechazada', id: -2 },
};

export const CURRENCIES = [
  { value: 'CLP', label: 'CLP' },
  { value: 'USD', label: 'USD' },
  { value: 'UF', label: 'UF' },
];

export const CONVERSION_RATES = {
  USD: 950,
  UF: 39000,
  CLP: 1,
};

export const SGR_TYPES = [
  { value: 'offer-seriousness', label: 'Seriedad de la Oferta' },
  { value: 'faithful-compliance', label: 'Fiel Cumplimiento' },
];

export const SGR_STATES = [
  { value: 'QUOTED', label: 'Cotizada', color: 'default', icon: Schedule },
  { value: 'REQUESTED', label: 'Solicitada', color: 'warning', icon: Info },
  { value: 'IN_REVIEW', label: 'En Revisión', color: 'warning', icon: Info },
  { value: 'REVIEWED', label: 'Revisada', color: 'info', icon: Info },
  { value: 'APPROVED', label: 'Aprobada', color: 'info', icon: CheckCircle },
  { value: 'ACTIVE', label: 'Activa', color: 'success', icon: CheckCircle },
  { value: 'REJECTED', label: 'Rechazada', color: 'error', icon: Cancel },
  { value: 'INACTIVE', label: 'Inactiva', color: 'error', icon: Cancel },
  { value: 'CANCELLED', label: 'Cancelada', color: 'error', icon: Cancel },
];

export const SGR_DEFAULT_RATES = {
  fixedRate: 19000,
  variableRate: 4.5,
  fixedDiscount: 0,
  variableDiscount: 0,
};
